import { render } from "./menuNotifications.vue?vue&type=template&id=3069f33e"
import script from "./menuNotifications.vue?vue&type=script&lang=js"
export * from "./menuNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__